import ChildBlock from "./template";

export default ChildBlock;